import { useState, useEffect, useCallback } from 'react';
import axiosInstance from "services/httpInterceptor";

function useProductAnalyticsData(targetCompanyId, presetKey, timeGranularity = 'daily') {

  const [trendsData, setTrendsData] = useState(null);
  const [topProductsData, setTopProductsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!targetCompanyId || !presetKey) {
      // Reset data if essential params are missing
      setTrendsData(null);
      setTopProductsData(null);
      setError(null); // Clear previous errors
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = {
        companyId: targetCompanyId,
        preset: presetKey.toUpperCase(),
        timeGranularity: timeGranularity,
      };
      
      const response = await axiosInstance.get('/v1/product-mention-analytics', { params });
      
      setTrendsData(response.data.trends || {}); // Default to empty object if undefined
      setTopProductsData(response.data.topProducts || []); // Default to empty array if undefined
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch product analytics data.');
      setTrendsData(null); // Clear data on error
      setTopProductsData(null);
    }
    setLoading(false);
  }, [targetCompanyId, presetKey, timeGranularity]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { trendsData, topProductsData, loading, error, refetch: fetchData };
}

export default useProductAnalyticsData; 